/**
 * i18next `returnObjects: true` returns the raw value; if the key is missing or wrong,
 * the fallback is often a string — never call `.map` on it without checking.
 */
export function stringArrayFromI18nReturn(value: unknown): string[] {
  return Array.isArray(value) && value.every((item) => typeof item === 'string') ? value : [];
}

/** Shortest accepted passphrase. Mirrors the API's minimum. */
export const MIN_PASSPHRASE_LENGTH = 8;

/** Coarse passphrase quality bands, used only to nudge toward longer phrases. */
export type PassphraseStrength = 'weak' | 'medium' | 'strong' | 'veryStrong';

/**
 * Rates a passphrase for encouragement, not enforcement: the only hard rule is
 * the 8-character minimum checked at submit. Scoring is length-only — requiring
 * (or forbidding) spaces would leak a fixed character into every strong secret.
 */
export function getPassphraseStrength(phrase: string): PassphraseStrength {
  const length = phrase.length;
  if (length >= 30) return 'veryStrong';
  if (length >= 24) return 'strong';
  if (length >= 12) return 'medium';
  return 'weak';
}
